export default {
  validate: (value, { char }) => {
    if(!value) return;

    return String(value).charAt(0) === char;
  },
  message: 'El campo {_field_} debe comenzar con {char}.',
  params: ['char']
}
